import NavBar from '../../../../component/b2c/navBar/navBar';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import { useMyContext } from '../../../../context/MyContext';
import { FaRupeeSign } from "react-icons/fa";
import { Base_Url, CodPlanChange, remmitance, settlecod } from '../../../../config/config';
import { toast } from 'react-toastify';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Building2 } from 'lucide-react';
import Spinner from '../../../../component/spinner/spinner'
import {
    Wallet,
    CheckCircle,
    Clock,
    Zap,
    Eye,
    ArrowUpRight,
    Download,
    Calendar,
    TrendingUp,
    CreditCard,
    X,
    Truck,
    Target,
    Timer,
    Building
} from 'lucide-react';

const PageRemittances = () => {
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [settlementDestination, setSettlementDestination] = useState('wallet');
    const [activePopup, setActivePopup] = useState(null);
    const [remittanceData, setRemittanceData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [settedCodData, setSetteledCodData] = useState();
    const token = localStorage.getItem('token');
    const [loadingCardId, setLoadingCardId] = useState(null);
    const cus_id = localStorage.getItem('cus_id');
    const { isDarkMode, isToggleSidebar } = useMyContext();
    const [selectedPlan, setSelectedPlan] = useState(null);

    // Mock data for demonstration
    useEffect(() => {
        fetchCod();
    }, []);

    const fetchCod = async () => {
        try {
            setLoading(true);
            const response = await fetch(Base_Url + remmitance, {
                method: 'GET',
                headers: {
                    cus_id: cus_id,
                    token: token,
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            if (data.status === "SUCCESS") {
                const apiData = data.data;
                const buttonStatus = apiData.button_status; // Get button status from API

                setSetteledCodData(apiData);
                setSelectedPlan(apiData.cod_plan);

                const formattedData = [
                    {
                        id: 'total',
                        title: 'Total Remittance',
                        amount: `₹${parseFloat(apiData.total_remittance.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
                        rawAmount: parseFloat(apiData.total_remittance.remaining_amount) || 0,
                        description: `After ${apiData.total_remittance.charge_percent}% charge deduction`,
                        apiData: {
                            totalAmount: apiData.total_remittance.amount,
                            chargePercent: apiData.total_remittance.charge_percent,
                            chargeAmount: apiData.total_remittance.charge_amount,
                            remainingAmount: apiData.total_remittance.remaining_amount,
                            orders: apiData.total_remittance.orders
                        },
                        buttonEnabled: buttonStatus === 'active', // Set button state based on API
                        icon: <Wallet className="w-8 h-8" />,
                        color: 'from-gray-900 via-gray-800 to-black',
                        bgColor: 'bg-blue-600',
                        iconColor: 'text-white',
                        glowColor: 'shadow-black/20',
                    },
                    {
                        id: 'last',
                        title: 'Last Remittance',
                        amount: `₹${parseFloat(apiData.last_remittance.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
                        rawAmount: parseFloat(apiData.last_remittance.remaining_amount) || 0,
                        description: apiData.last_remittance_date
                            ? `Settled on ${new Date(apiData.last_remittance_date).toLocaleDateString('en-IN', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric'
                            })}`
                            : 'No previous settlement',
                        apiData: {
                            totalAmount: apiData.last_remittance.amount,
                            chargePercent: apiData.last_remittance.charge_percent,
                            chargeAmount: apiData.last_remittance.charge_amount,
                            remainingAmount: apiData.last_remittance.remaining_amount,
                            orders: apiData.last_remittance.orders,
                            date: apiData.last_remittance_date
                        },
                        icon: <CheckCircle className="w-8 h-8" />,
                        color: 'from-gray-700 via-gray-600 to-gray-800',
                        bgColor: 'bg-blue-600',
                        iconColor: 'text-white',
                        glowColor: 'shadow-black/20',
                    },
                    {
                        id: 'next',
                        title: 'Next Remittance',
                        amount: `₹${parseFloat(apiData.next_remittance.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
                        rawAmount: parseFloat(apiData.next_remittance.remaining_amount) || 0,
                        description: apiData.next_remittance_date
                            ? `Scheduled for ${new Date(apiData.next_remittance_date).toLocaleDateString('en-IN', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric'
                            })}`
                            : 'No upcoming settlement',
                        apiData: {
                            totalAmount: apiData.next_remittance.amount,
                            chargePercent: apiData.next_remittance.charge_percent,
                            chargeAmount: apiData.next_remittance.charge_amount,
                            remainingAmount: apiData.next_remittance.remaining_amount,
                            orders: apiData.next_remittance.orders,
                            date: apiData.next_remittance_date
                        },
                        icon: <Clock className="w-8 h-8" />,
                        color: 'from-gray-500 via-gray-600 to-gray-700',
                        bgColor: 'bg-blue-600',
                        iconColor: 'text-white',
                        glowColor: 'shadow-black/20',
                    }
                ];

                setRemittanceData(formattedData);
            } else {
                toast.error(data.message || 'Failed to fetch remittance data');
            }
        } catch (error) {
            console.error('Error fetching COD:', error);
            toast.error('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    // Payout frequency cards data
    const payoutCards = [
        {
            id: 'D+1',
            frequency: '20 Payouts/Months',
            title: 'Delivered + 1 Day',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '2% of COD amount',
            note: '(Inclusive GST)',
            icon: <Truck className="w-8 h-8" />,
            color: 'from-gray-900 to-black',
            bgColor: 'bg-red-600',
            iconColor: 'text-white'
        },
        {
            id: 'D+2',
            frequency: '20 Payouts/Months',
            title: 'Delivered + 2 Days',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '1.75% of COD amount',
            note: '(Inclusive GST)',
            icon: <Target className="w-8 h-8" />,
            color: 'from-gray-800 to-gray-900',
            bgColor: 'bg-red-600',
            iconColor: 'text-white'
        },
        {
            id: 'D+3',
            frequency: '8 Payouts/Months',
            title: 'Delivered + 3 Days',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '1% of COD amount',
            note: '(Inclusive GST)',
            icon: <Timer className="w-8 h-8" />,
            color: 'from-gray-700 to-gray-800',
            bgColor: 'bg-red-600',
            iconColor: 'text-white'
        },
        {
            id: 'D+4',
            frequency: '8 Payouts/Months',
            title: 'Delivered + 4 Days',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '0.75% of COD amount',
            note: '(Inclusive GST)',
            icon: <Building className="w-8 h-8" />,
            color: 'from-gray-600 to-gray-700',
            bgColor: 'bg-red-600',
            iconColor: 'text-white'
        }
    ];

    const handleSettleNow = (cardId) => {
        setActivePopup(cardId);
    };

    const closePopup = () => {
        setActivePopup(null);
    };

    const handleActivatePayout = async (cardId) => {
        try {
            setLoadingCardId(cardId)
            setLoading(true);
            const apiUrl = Base_Url + CodPlanChange;

            // Set headers
            const headers = {
                cus_id: cus_id,
                token: token,
                'Content-Type': 'application/json',
            };

            // Set payload
            const payload = {
                retailer_id: cus_id,
                plan: cardId,
                status: "Active"
            };

            // Make POST request
            const response = await axios.post(apiUrl, payload, { headers });

            if (response.data?.status === 'SUCCESS') {
                toast.success(response.data.message);
                setLoading(false);
            } else {
                toast.error(response.data.message);
                setLoading(false);
            }
        } catch (error) {
            console.error('API error:', error);
            setLoading(false);
        }
        finally {
            setLoadingCardId(null);
        }
    };

    const reqForSettelod = async () => {
        try {
            setLoading(true);
            const apiUrl = Base_Url + settlecod;

            const headers = {
                cus_id: cus_id,
                token: token,
                'Content-Type': 'application/json',
            };

            // Assuming settedCodData is the full API response JSON
            const totalRemittance = settedCodData?.total_remittance;

            // Fallback if orders array is not available
            const ordersArray = totalRemittance?.orders?.map(order => ({
                amount: order.amount.replace(/,/g, ''),
                order_id: order.order_id,
            })) || [];

            const payload = {
                retailer_id: cus_id,
                remaining_amount: Number(
                    (totalRemittance?.remaining_amount || '0').replace(/,/g, '')
                ).toFixed(2),
                order_ids: ordersArray,
                settle_type: settlementDestination
            };

            const response = await axios.post(apiUrl, payload, { headers });

            if (response.data?.status === 'SUCCESS') {
                toast.success(response.data.message);
                setActivePopup(null);
            } else {
                const errorMessage = typeof response.data.message === 'object'
                    ? Object.values(response.data.message).join(', ')
                    : response.data.message || 'Something went wrong!';
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error('Something went wrong!');
        } finally {
            setLoading(false);
        }
    };
    const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-white'}`}>
            <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />
      
              <NavBar />
              <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && (
                  <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
                    <Sidebar />
                  </div>
                )}
                {/* Main Content */}
                <div className="flex-1 p-2 bg-gray-200 dark:bg-black overflow-y-auto">
                    <div className="max-w-7xl mx-auto w-full">
                        {/* Enhanced Header */}
                        <div className="mb-2 text-center">
                            <div className="inline-flex items-center gap-1.5">
                                <div className={`p-1 rounded-md border ${isDarkMode ? 'border-white/20 bg-white/5' : 'border-black/10 bg-black/5'}`}>
                                    <FaRupeeSign className={`w-3.5 h-3.5 ${isDarkMode ? 'text-white' : 'text-black'}`} />
                                </div>
                                <h1 className={`text-sm font-bold tracking-tight ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                    Remittance Dashboard
                                </h1>
                            </div>
                            <p className={`text-[10px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'} mt-0.5`}>
                                Monitor settlements, history & payouts
                            </p>
                        </div>

                        {/* Enhanced Cards Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-2">
                            {remittanceData.map((card, index) => (
                                <div
                                    key={card.id}
                                    className={`group relative overflow-hidden rounded-lg border transition-all duration-200 ${isDarkMode ? 'bg-white/5 border-white/15 hover:border-white/30' : 'bg-white border-black/10 hover:border-black/30'}`}
                                >
                                    {/* Card Content */}
                                    <div className="relative p-2">
                                        {/* Title with Icon */}
                                        <div className="flex items-center gap-1.5 mb-1">
                                            <div className={`inline-flex items-center justify-center w-5 h-5 rounded-md ${card.bgColor}`}>
                                                <div className={`${card.iconColor}`}>
                                                    {React.cloneElement(card.icon, { className: "w-2.5 h-2.5" })}
                                                </div>
                                            </div>
                                            <h3 className={`text-[11px] font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                                {card.title}
                                            </h3>
                                        </div>

                                        {/* Main Amount */}
                                        <div className={`text-base ml-6.5 font-black mb-1 ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                            {card.apiData.totalAmount}
                                        </div>

                                        {/* Enhanced Info Section for Total Remittance */}
                                        {card.id === 'total' && (
                                            <div className={`mb-1 p-1.5 rounded-md border ${isDarkMode ? 'border-white/10 bg-white/5' : 'border-black/10 bg-black/[0.03]'}`}>
                                                <div className="space-y-0.5">
                                                    <div className="flex items-center justify-between">
                                                        <span className={`text-[10px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                            Total COD
                                                        </span>
                                                        <span className={`text-[10px] font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                                            ₹{card.apiData?.totalAmount}
                                                        </span>
                                                    </div>
                                                    <div className="flex items-center justify-between">
                                                        <span className={`text-[10px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                            Charge ({card.apiData?.chargePercent}%)
                                                        </span>
                                                        <span className={`text-[10px] font-bold ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                            -₹{card.apiData?.chargeAmount}
                                                        </span>
                                                    </div>
                                                    <div className={`flex items-center justify-between pt-1 border-t ${isDarkMode ? 'border-white/10' : 'border-black/10'}`}>
                                                        <span className={`text-[10px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                            Net Amount
                                                        </span>
                                                        <span className={`text-[10px] font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                                            ₹{card.apiData?.remainingAmount}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Additional Info Section for Last & Next Remittance */}
                                        {card.id === 'last' && (
                                            <div className={`mb-1 p-1.5 rounded-md border ${isDarkMode ? 'border-white/10 bg-white/5' : 'border-black/10 bg-black/[0.03]'}`}>
                                                <div className="flex items-center justify-between mb-0.5">
                                                    <span className={`text-[10px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                        Settlement Date
                                                    </span>
                                                    <span className={`text-[10px] font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                                        26 Jun 2025
                                                    </span>
                                                </div>
                                                <div className="flex items-center justify-between">
                                                    <span className={`text-[10px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                        Status
                                                    </span>
                                                    <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded-full border ${isDarkMode ? 'border-white/20 text-white' : 'border-black/20 text-black'}`}>
                                                        Completed
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        {card.id === 'next' && (
                                            <div className={`mb-1 p-1.5 rounded-md border ${isDarkMode ? 'border-white/10 bg-white/5' : 'border-black/10 bg-black/[0.03]'}`}>
                                                <div className="flex items-center justify-between mb-0.5">
                                                    <span className={`text-[10px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                        Scheduled Date
                                                    </span>
                                                    <span className={`text-[10px] font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                                        30 Jun 2025
                                                    </span>
                                                </div>
                                                <div className="flex items-center justify-between">
                                                    <span className={`text-[10px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                        Status
                                                    </span>
                                                    <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded-full border ${isDarkMode ? 'border-white/20 text-white' : 'border-black/20 text-black'}`}>
                                                        Pending
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        {/* Order Count for All Cards */}
                                        <div className={`mb-1.5 p-1.5 rounded-md ${isDarkMode ? 'bg-white/5' : 'bg-black/[0.03]'}`}>
                                            <div className="flex items-center justify-between">
                                                <span className={`text-[10px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                    {card.id === 'last' ? 'Completed Orders' : 'Orders'}
                                                </span>
                                                <span className={`text-[9px] font-medium px-1.5 py-0.5 rounded-full border ${isDarkMode ? 'border-white/20 text-white' : 'border-black/20 text-black'}`}>
                                                    {card.apiData?.orders?.length || 0} orders
                                                </span>
                                            </div>
                                            <div className="mt-0.5">
                                                <span className={`text-[9px] leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                    {card.description}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Action Buttons */}
                                        <div className="flex gap-1.5">
                                            {card.id === 'total' ? (
                                                <>
                                                    {/* SETTLE NOW button */}
                                                    <button
                                                        onClick={() => handleSettleNow(card.id)}
                                                        disabled={!card.buttonEnabled}
                                                        className={`flex-1 py-1.5 px-2 rounded-md font-bold text-[10px] transition-all duration-200 ${card.buttonEnabled
                                                            ? (isDarkMode ? 'bg-white text-black hover:bg-gray-200' : 'bg-black text-white hover:bg-gray-800')
                                                            : (isDarkMode ? 'bg-white/10 text-gray-500 cursor-not-allowed' : 'bg-black/10 text-gray-400 cursor-not-allowed')
                                                            }`}
                                                    >
                                                        <div className="flex items-center justify-center gap-1">
                                                            <Zap className="w-2.5 h-2.5" />
                                                            {card.buttonEnabled ? 'Settle Now' : 'Not Available'}
                                                        </div>
                                                    </button>

                                                    {/* Eye button */}
                                                    <button
                                                        onClick={() => {
                                                            const activeCard = remittanceData.find(c => c.id === 'total');
                                                            setSelectedOrders(activeCard?.apiData?.orders || []);
                                                            setIsModalOpen(true);
                                                        }}
                                                        className={`p-1.5 rounded-md border transition-all duration-200 ${isDarkMode
                                                            ? 'border-white/20 hover:bg-white/10 text-white'
                                                            : 'border-black/20 hover:bg-black/5 text-black'
                                                            }`}
                                                    >
                                                        <Eye className="w-2.5 h-2.5" />
                                                    </button>
                                                </>
                                            ) : (
                                                <>
                                                    {/* View Details / Schedule Info */}
                                                    <button
                                                        onClick={() => {
                                                            const key = card.id === 'last' ? 'last' : 'next';
                                                            const activeCard = remittanceData.find(c => c.id === key);
                                                            setSelectedOrders(activeCard?.apiData?.orders || []);
                                                            setIsModalOpen(true);
                                                        }}
                                                        className={`flex-1 py-1.5 px-2 rounded-md font-bold text-[10px] transition-all duration-200 border ${isDarkMode
                                                            ? 'border-white/20 hover:bg-blue-600 text-white'
                                                            : 'border-black/20 bg-blue-600 hover:bg-blue-400 text-white'
                                                            }`}
                                                    >
                                                        <div className="flex items-center justify-center gap-1">
                                                            {card.id === 'last' ? (
                                                                'View Details'
                                                            ) : card.id === 'next' ? (
                                                                <>
                                                                    <Clock className="w-2.5 h-2.5" />
                                                                    Schedule Info
                                                                </>
                                                            ) : null}
                                                        </div>
                                                    </button>

                                                    {/* Download / Calendar Icon Button */}
                                                    <button
                                                        className={`p-1.5 rounded-md border transition-all duration-200 ${isDarkMode
                                                            ? 'border-white/20 hover:bg-white/10 text-white'
                                                            : 'border-black/20 hover:bg-black/5 text-black'
                                                            }`}
                                                    >
                                                        {card.id === 'last' ? (
                                                            <Download className="w-2.5 h-2.5" />
                                                        ) : (
                                                            <Calendar className="w-2.5 h-2.5" />
                                                        )}
                                                    </button>
                                                </>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* New Payout Frequency Cards Section */}
                        <div className="mb-2">
                            <div className="text-center mb-1.5">
                                <h2 className={`text-xs font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                    Payout Frequency Plans
                                </h2>
                                <p className={`text-[9px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                    Choose the payout schedule that fits your business
                                </p>
                            </div>

                            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                                {payoutCards.map((card, index) => {
                                    const isDisabled = selectedPlan && selectedPlan !== card.id;
                                    return (
                                        <div
                                            key={card.id}
                                            className={`relative overflow-hidden rounded-lg border transition-all duration-200
                ${isDisabled ? ' cursor-not-allowed pointer-events-none' : ''}
                ${isDarkMode ? 'bg-white/5 border-white/15' : 'bg-white border-black/10'}`}
                                        >
                                            {/* Card Content */}
                                            <div className="pt-2 pb-2 px-2 text-center">
                                                <div className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${card.bgColor} mb-1 mx-auto`}>
                                                    <div className={card.iconColor}>
                                                        {React.cloneElement(card.icon, { className: "w-3 h-3" })}
                                                    </div>
                                                </div>

                                                <h3 className={`text-[10px] font-bold mb-0.5 ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                                    {card.title}
                                                </h3>

                                                <p className={`text-[8px] mb-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                    {card.subtitle}
                                                </p>

                                                <div className={`text-xs font-bold mb-0.5 ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                                    {card.percentage}
                                                </div>

                                                <p className={`text-[8px] mb-1.5 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                                                    {card.note}
                                                </p>

                                                <button
                                                    onClick={() => handleActivatePayout(card.id)}
                                                    disabled={isDisabled || loadingCardId === card.id}
                                                    className={`w-full py-1 px-2 rounded-md font-bold text-[10px] transition-all duration-200
                        ${isDisabled ? (isDarkMode ? 'bg-white/10 text-gray-500' : 'bg-black/10 text-gray-400') : (isDarkMode ? 'bg-white text-black hover:bg-gray-200' : 'bg-red-600 text-white hover:bg-red-400')}`}
                                                >
                                                    {loadingCardId === card.id ? (
                                                        <div className="flex justify-center items-center">
                                                            <Spinner />
                                                        </div>
                                                    ) : (
                                                        "Activate"
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Additional Stats Section */}
                        <div className={`p-2.5 rounded-lg border ${isDarkMode ? 'bg-white/5 border-white/15' : 'bg-white border-black/10'}`}>
                            <div className="flex items-center justify-between mb-1.5">
                                <h2 className={`text-xs font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                    Quick Actions
                                </h2>
                                <button className={`flex items-center gap-1 px-2 py-1 rounded-md text-[10px] border transition-colors ${isDarkMode ? 'border-white/20 hover:bg-white/10 text-white' : 'border-black/20 bg-emerald-600 hover:bg-black/5 text-white'}`}>
                                    <Download className="w-2.5 h-2.5" />
                                    Export
                                </button>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                                <div className={`p-2 rounded-md border cursor-pointer transition-colors ${isDarkMode ? 'border-white/15 hover:bg-white/10' : 'border-black/10 hover:bg-black/5'}`}>
                                    <Calendar className={`w-3.5 h-3.5 mb-1 ${isDarkMode ? 'text-white' : 'text-black'}`} />
                                    <h3 className={`text-[10px] font-semibold ${isDarkMode ? 'text-white' : 'text-black'}`}>Schedule Settlement</h3>
                                    <p className={`text-[9px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Set up automatic payouts</p>
                                </div>

                                <div className={`p-2 rounded-md border cursor-pointer transition-colors ${isDarkMode ? 'border-white/15 hover:bg-white/10' : 'border-black/10 hover:bg-black/5'}`}>
                                    <TrendingUp className={`w-3.5 h-3.5 mb-1 ${isDarkMode ? 'text-white' : 'text-black'}`} />
                                    <h3 className={`text-[10px] font-semibold ${isDarkMode ? 'text-white' : 'text-black'}`}>View Analytics</h3>
                                    <p className={`text-[9px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Detailed payment insights</p>
                                </div>

                                <div className={`p-2 rounded-md border cursor-pointer transition-colors ${isDarkMode ? 'border-white/15 hover:bg-white/10' : 'border-black/10 hover:bg-black/5'}`}>
                                    <CreditCard className={`w-3.5 h-3.5 mb-1 ${isDarkMode ? 'text-white' : 'text-black'}`} />
                                    <h3 className={`text-[10px] font-semibold ${isDarkMode ? 'text-white' : 'text-black'}`}>Payment Methods</h3>
                                    <p className={`text-[9px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Manage bank accounts</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Enhanced Popup Modal */}

            {activePopup && (
                <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                    <div className={`relative max-w-md w-full rounded-xl border ${isDarkMode ? 'bg-black text-white border-white/20' : 'bg-white border-black/10'} transform transition-all duration-300 scale-100`}>

                        {/* Close Button */}
                        <button
                            onClick={closePopup}
                            className={`absolute top-3 right-3 p-1.5 rounded-full transition-all duration-200 ${isDarkMode ? 'hover:bg-white/10 text-gray-400 hover:text-white' : 'hover:bg-black/5 text-gray-500 hover:text-black'}`}
                        >
                            <X className="w-4 h-4" />
                        </button>

                        <div className="p-4">
                            {/* Enhanced Icon */}
                            <div className="flex justify-center mb-3">
                                <div className={`w-12 h-12 rounded-full flex items-center justify-center border-2 ${isDarkMode ? 'border-white bg-white/10' : 'border-black bg-black/5'}`}>
                                    <CreditCard className={`w-5 h-5 ${isDarkMode ? 'text-white' : 'text-black'}`} />
                                </div>
                            </div>

                            {/* Title */}
                            <h2 className={`text-sm font-bold text-center mb-3 ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                Request For Settlement
                            </h2>

                            {/* Settlement Details Table */}
                            <div className={`mb-3 p-2.5 rounded-lg border ${isDarkMode ? 'border-white/15 bg-white/5' : 'border-black/10 bg-black/[0.03]'}`}>
                                <div className="overflow-hidden rounded-md">
                                    <table className="w-full">
                                        <tbody className={`divide-y ${isDarkMode ? 'divide-white/10' : 'divide-black/10'}`}>
                                            <tr>
                                                <td className={`py-1.5 text-[10px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                    Total COD
                                                </td>
                                                <td className={`py-1.5 text-right text-[10px] font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                                    ₹{remittanceData.find(card => card.id === activePopup)?.apiData?.totalAmount || '0'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className={`py-1.5 text-[10px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                    Charge Rate
                                                </td>
                                                <td className={`py-1.5 text-right text-[10px] font-bold ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                    {remittanceData.find(card => card.id === activePopup)?.apiData?.chargePercent || '0'}%
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className={`py-1.5 text-[10px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                    Charge Amount
                                                </td>
                                                <td className={`py-1.5 text-right text-[10px] font-bold ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                    -₹{remittanceData.find(card => card.id === activePopup)?.apiData?.chargeAmount || '0'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className={`py-1.5 text-[10px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                    Total Orders
                                                </td>
                                                <td className={`py-1.5 text-right text-[10px] font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                                    {remittanceData.find(card => card.id === activePopup)?.apiData?.orders?.length || '0'} orders
                                                </td>
                                            </tr>
                                            <tr className={`border-t ${isDarkMode ? 'border-white/15' : 'border-black/15'}`}>
                                                <td className={`py-1.5 text-[10px] font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                                    Settlement Amount
                                                </td>
                                                <td className={`py-1.5 text-right text-sm font-black ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                                    ₹{remittanceData.find(card => card.id === activePopup)?.apiData?.remainingAmount || '0'}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* View Orders Button */}
                            <div className={`mb-3 p-2 rounded-lg border ${isDarkMode ? 'border-white/10 bg-white/5' : 'border-black/10 bg-black/[0.03]'}`}>
                                <button
                                    onClick={() => {
                                        const activeCard = remittanceData.find(card => card.id === activePopup);
                                        setSelectedOrders(activeCard?.apiData?.orders || []);
                                        setIsModalOpen(true);
                                    }}
                                    className={`w-full py-1.5 px-3 rounded-md font-medium text-[10px] transition-all duration-200 border ${isDarkMode ? 'border-white/20 hover:bg-white/10 text-white' : 'border-black/20 hover:bg-black/5 text-black'}`}
                                >
                                    <div className="flex items-center justify-center gap-1.5">
                                        <Eye className="w-3 h-3" />
                                        View Orders ({remittanceData.find(card => card.id === activePopup)?.apiData?.orders?.length || '0'})
                                    </div>
                                </button>
                            </div>

                            {/* Settlement Destination Radio Buttons */}
                            <div className={`mb-3 p-2.5 rounded-lg border ${isDarkMode ? 'border-white/10 bg-white/5' : 'border-black/10 bg-black/[0.03]'}`}>
                                <p className={`text-[10px] font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                    Select settlement destination:
                                </p>

                                <div className="flex gap-2">
                                    {/* Wallet Option */}
                                    <label className={`flex-1 flex items-center p-2 rounded-md cursor-pointer transition-all duration-200 border-2 ${settlementDestination === 'wallet'
                                        ? (isDarkMode ? 'border-white bg-white/10' : 'border-black bg-black/5')
                                        : (isDarkMode ? 'border-white/15 hover:bg-white/5' : 'border-black/10 hover:bg-black/[0.03]')
                                        }`}>
                                        <input
                                            type="radio"
                                            name="settlementDestination"
                                            value="wallet"
                                            checked={settlementDestination === 'wallet'}
                                            onChange={(e) => setSettlementDestination(e.target.value)}
                                            className="sr-only"
                                        />
                                        <div className={`w-3 h-3 rounded-full border-2 mr-2 flex items-center justify-center ${settlementDestination === 'wallet'
                                            ? (isDarkMode ? 'border-white bg-white' : 'border-black bg-black')
                                            : (isDarkMode ? 'border-gray-500' : 'border-gray-300')
                                            }`}>
                                            {settlementDestination === 'wallet' && (
                                                <div className={`w-1 h-1 rounded-full ${isDarkMode ? 'bg-black' : 'bg-white'}`}></div>
                                            )}
                                        </div>
                                        <div className="flex items-center">
                                            <Wallet className={`w-3 h-3 mr-1.5 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`} />
                                            <span className={`text-[10px] font-medium ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                                Wallet
                                            </span>
                                        </div>
                                    </label>

                                    {/* Bank Account Option */}
                                    <label className={`flex-1 flex items-center p-2 rounded-md cursor-pointer transition-all duration-200 border-2 ${settlementDestination === 'bank'
                                        ? (isDarkMode ? 'border-white bg-white/10' : 'border-black bg-black/5')
                                        : (isDarkMode ? 'border-white/15 hover:bg-white/5' : 'border-black/10 hover:bg-black/[0.03]')
                                        }`}>
                                        <input
                                            type="radio"
                                            name="settlementDestination"
                                            value="bank"
                                            checked={settlementDestination === 'bank'}
                                            onChange={(e) => setSettlementDestination(e.target.value)}
                                            className="sr-only"
                                        />
                                        <div className={`w-3 h-3 rounded-full border-2 mr-2 flex items-center justify-center ${settlementDestination === 'bank'
                                            ? (isDarkMode ? 'border-white bg-white' : 'border-black bg-black')
                                            : (isDarkMode ? 'border-gray-500' : 'border-gray-300')
                                            }`}>
                                            {settlementDestination === 'bank' && (
                                                <div className={`w-1 h-1 rounded-full ${isDarkMode ? 'bg-black' : 'bg-white'}`}></div>
                                            )}
                                        </div>
                                        <div className="flex items-center">
                                            <Building2 className={`w-3 h-3 mr-1.5 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`} />
                                            <span className={`text-[10px] font-medium ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                                Bank Account
                                            </span>
                                        </div>
                                    </label>
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="flex gap-2">
                                <button
                                    onClick={closePopup}
                                    className={`flex-1 py-2 px-3 rounded-lg font-bold border-2 text-[10px] transition-all duration-200 ${isDarkMode ? 'border-white/20 text-gray-300 hover:bg-white/10' : 'border-black/20 text-gray-700 hover:bg-black/5'}`}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={reqForSettelod}
                                    className={`flex-1 py-2 px-3 rounded-lg font-bold text-[10px] transition-all duration-200 ${isDarkMode ? 'bg-white text-black hover:bg-gray-200' : 'bg-black text-white hover:bg-gray-800'}`}
                                >
                                    <div className="flex items-center justify-center gap-1.5">
                                        <Zap className="w-3 h-3" />
                                        {loading ? <Spinner /> : "Send Request"}
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isModalOpen && (
                <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
                    <div className={`p-3 rounded-xl w-[90%] max-w-md border ${isDarkMode ? 'bg-black border-white/20' : 'bg-white border-black/10'}`}>
                        <div className="flex justify-between items-center mb-2">
                            <h3 className={`text-xs font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>Order Details</h3>
                            <button onClick={() => setIsModalOpen(false)} className={`font-bold text-base ${isDarkMode ? 'text-white' : 'text-black'}`}>&times;</button>
                        </div>
                        {selectedOrders.length > 0 ? (
                            <ul className={`divide-y max-h-60 overflow-y-auto ${isDarkMode ? 'divide-white/10' : 'divide-black/10'}`}>
                                {selectedOrders.map((order, idx) => (
                                    <li key={idx} className={`flex justify-between py-1.5 text-[10px] ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                                        <span>Order ID: {order.order_id}</span>
                                        <span>₹{order.amount}</span>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className={`text-[10px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>No orders available.</p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PageRemittances;